import { createBrowserRouter, Navigate } from 'react-router-dom'
import children from './routes'
import Layout from 'layout'
import { AuthStore } from '../store/AuthStore'
import { observer } from 'mobx-react-lite'
import AuthLayout from '../layout/Auth'
import LoginPage from '../pages/loginPage'
import RestorePage from '../pages/restorePage'

const Dashboard = observer(() => {
  if (AuthStore.isUserAuthenticated) {
    return <Layout />
  } else {
    return <Navigate to="/auth" />
  }
})

const Auth = observer(() => {
  if (!AuthStore.isUserAuthenticated) {
    return <AuthLayout />
  } else {
    return <Navigate to="/" />
  }
})

const ErrorElement = observer(() => {
  if (AuthStore.isUserAuthenticated) {
    return <Navigate to="/review?period=week" />
  } else {
    return <Navigate to="/auth" />
  }
})

const createRouter = () =>
  createBrowserRouter(
    [
      {
        path: '/',
        element: <Dashboard />,
        errorElement: <ErrorElement />,
        children,
      },
      {
        path: '/auth',
        element: <Auth />,
        children: [
          {
            path: '/auth',
            element: <LoginPage />,
          },
          {
            path: 'restore',
            element: <RestorePage />,
          },
        ],
      },
    ],
    { basename: process.env.REACT_APP_BASE_PATH || '/' }
  )

export default createRouter
